// Utility for storing and loading the auth token in a cookie

export function setAuthTokenCookie(token) {
  document.cookie = `authToken=${encodeURIComponent(token)}; path=/; max-age=31536000`;
}

export function getAuthTokenCookie() {
  const match = document.cookie.match(/(?:^|; )authToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
